module.exports = __webpack_public_path__ + "img/logo_sf.d87ba2f6.svg";